import React from 'react';

export function SportCard({ title, description, icon = '🏆', onClick, className = '' }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      className={`sp-sport-card ${className}`.trim()}
      onClick={onClick}
      style={onClick ? { border: 'none', textAlign: 'left', width: '100%' } : undefined}
    >
      <div className="sp-sport-card__media">{icon}</div>
      <div className="sp-sport-card__title">{title}</div>
      {description && <div className="sp-sport-card__desc">{description}</div>}
    </Tag>
  );
}

export function DataCard({ children, className = '' }) {
  return <div className={`sp-data-card ${className}`.trim()}>{children}</div>;
}

export function StatCard({ label, value, hint, className = '' }) {
  return (
    <div className={`sp-stat-card ${className}`.trim()}>
      {label && <div style={{ fontSize: 13, color: 'var(--sp-gray-400)', textTransform: 'uppercase', fontWeight: 700 }}>{label}</div>}
      <div style={{ fontFamily: 'var(--sp-font-heading)', fontSize: 40, fontWeight: 700, lineHeight: 1.1, marginTop: 8 }}>{value}</div>
      {hint && <div style={{ fontSize: 13, color: 'var(--sp-gray-400)', marginTop: 4 }}>{hint}</div>}
    </div>
  );
}

export default function Card({ variant = 'data', ...props }) {
  if (variant === 'sport') return <SportCard {...props} />;
  if (variant === 'stat') return <StatCard {...props} />;
  return <DataCard {...props} />;
}
